// extracted by mini-css-extract-plugin
export default {"container":"YJ-z","error":"ZJ-z","disabled":"_J-z","submit":"aK-z","option":"bK-z","success":"cK-z","failure":"dK-z"};